export class PaymentPdfEmailDto {
    accountId = 0;
    startDate: Date | null = null;
    endDate: Date | null = null;
    dateSeleccionRange = "";
    subject = "";
    emailBody = "";
    emailRecipients = "";
    loggedInUserEmail = "";
}